import Crud from '../views/Configuracao/Crud'
import Entity from '../views/Configuracao/Add'
import View from '../views/Configuracao/View'

let routes = {
    path: '/configuracoes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/configuracoes/add',
            name: 'NewConfiguracao',
            component: Entity
        },
        {
            path: '/configuracoes/edit/:id?',
            name: 'EditConfiguracao',
            component: Entity,
            meta: {
                pageTitle: 'Editar Configurações',
                breadcrumb: [
                    {
                        text: 'Configurações',
                        active: false,
                        to: '/configuracoes',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/configuracoes/view/:id?',
            name: 'ViewConfiguracao',
            component: View,
            meta: {
                pageTitle: 'Visualizar Configurações',
                breadcrumb: [
                    {
                        text: 'Configurações',
                        active: false,
                        to: '/configuracoes',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/configuracoes',
            name: 'list-configuracoes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Configurações',
                breadcrumb: [
                    {
                        text: 'Configurações',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
